import type { ServicePricing } from './api';

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

function isWeekend(dateYmd: string): boolean {
  const day = new Date(`${dateYmd}T12:00:00`).getDay();
  return day === 0 || day === 6;
}

/**
 * Resolve display price for a given calendar day.
 * Weekend and special dates use weekend price (fallback: default).
 */
export function resolvePriceForDate(
  pricing: ServicePricing | undefined | null,
  fallbackPrice: string | undefined,
  dateYmd: string | null | undefined
): string {
  const defaultPrice = (pricing?.default || fallbackPrice || '').trim();
  const weekendPrice = (pricing?.weekend || defaultPrice).trim();

  if (!dateYmd) {
    return defaultPrice;
  }

  const specialDates = pricing?.special_dates ?? [];
  if (specialDates.includes(dateYmd) || isWeekend(dateYmd)) {
    return weekendPrice || defaultPrice;
  }

  return defaultPrice;
}
